import { SearchService } from '@lib/constants/variants';
import { useEffect, useState } from 'react';
import { useApi } from '@lib/hooks/use-api';
import { getLogger } from '@lib/util/logging-util';

const logger = getLogger();

export const getImage = async (srcUrl: string, callback: any, googleApiKey: string, size = 800) => {
  const url = `https://places.googleapis.com/v1/${srcUrl}/media?key=${googleApiKey}&maxWidthPx=${size}&maxHeightPx=${size}`;
  try {
    const response: any = await fetch(url);
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }
    callback?.(response?.url);
  } catch (error) {
    logger.error(error);
  }
};

export const useImageBySearch = (src: string, type = 'yelp', size = 800) => {
  const api = useApi();
  const [isLoading, setIsLoading] = useState(true);
  const [imageSrc, setImageSrc] = useState<string>('');

  useEffect(() => {
    setIsLoading(true);
    if (src) {
      if (type === SearchService.YELP || src?.toLowerCase().includes('yelpcdn.com')) {
        setImageSrc(src);
        setIsLoading(false);
      } else {
        // Don't set initial src for Google images - wait for API response
        // to avoid browser treating it as relative URL
        getImage(
          src,
          (srcUrl: any) => {
            setImageSrc(srcUrl);
            setIsLoading(false);
          },
          api.googleApiKey || '',
          size
        );
      }
    }
  }, [src, api.googleApiKey]);

  return { isLoading, imageSrc };
};
